/**
 * Title cases the string provided.
 *
 * @example
 * TitleCase("daniel Is theRe")  // Daniel Is There
 * TitleCase("dAniel;iS;thEre", {noSplit: true})  // Daniel;is;there
 * TitleCase("dAniel;iS;thEre", {splitChar: ';'})  // Daniel;Is;There
 *
 * @param s input string
 * @param options other options to manipulate title case operation
 */
export function TitleCase(
    s: string,
    options = {
        noSplit: false,
        splitChar: " ",
        joinChar: " "
    }
) {
    if (s.length <= 1) return s.toUpperCase();

    const titleCase = (e: string) => e[0].toUpperCase() + e.substr(1).toLowerCase();

    const {splitChar = " ", noSplit = false, joinChar = " "} = options;

    if (noSplit) {
        return titleCase(s);
    }

    return s
        .split(splitChar)
        .map(titleCase)
        .join(joinChar);
}


export function TitleCamelCase(s:string) {
  return TitleCase(camelToSnake(s), {noSplit: false, splitChar: "_", joinChar: " "})
}

export function camelToSnake(s:string) {
  return s.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
}

export function slugify(text: string) {
  return text
    .toLowerCase()
    .trim()
    .replace(/\s\s+/g, "-")
    .replace(/ /g, "-");
}
